// extracted by mini-css-extract-plugin
export default {"mailIcon":"SelectControl_mailIcon__k3ICO","select":"SelectControl_select__oCY4P"};